import SocialButton from "@/features/auth/social-buttons/social-button";

export default function FacebookSocialButton() {
  return <SocialButton bgColor="#1877F2" name="Facebook" src="/ic_fb.svg" />;
}
